export const state = {
  analyst: null,
  analysts: []
}

export default state



// WEBPACK FOOTER //
// ./src/store/module/analyst/state.js